import { render } from "./AppDescription.vue?vue&type=template&id=780f08a4&scoped=true&lang=pug"
import script from "./AppDescription.vue?vue&type=script&lang=js"
export * from "./AppDescription.vue?vue&type=script&lang=js"

import "./AppDescription.vue?vue&type=style&index=0&id=780f08a4&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-780f08a4"]])

export default __exports__